// session存储（设置、获取、删除）
const sessionOrLocal = {
  set: (key, value, saveType = 'sessionStorage') => {
    if (!key) return
    if (typeof value !== 'string') {
      value = JSON.stringify(value)
    }
    // alert(`当前${sessionOrLocal.saveType}`);
    window[saveType].setItem(key, value)
  },
  get: (key, saveType = 'sessionStorage') => {
    if (!key) return
    return window[saveType].getItem(key)
  },
  removeItem: (key, saveType = 'sessionStorage') => {
    if (!key) return
    window[saveType].removeItem(key)
  },
  clear: (saveType = 'sessionStorage') => {
    window[saveType].clear()
  },
}

function getCookie(cookieName) {
  let cookie = {}
  document.cookie.split(';').forEach(function (el) {
    let [key, value] = el.split('=')
    cookie[key.trim()] = value
  })
  return cookie[cookieName]
}

export { sessionOrLocal, getCookie }
